import React from 'react'

export const Recent= () =>{
    return(
        <div>
          <br></br><br></br><br></br>
          <div>
         Recent  page placeholder 
         </div>
  </div>
    )
}
export default Recent;